import BasemapToggle from "@arcgis/core/widgets/BasemapToggle";
import Basemap from "@arcgis/core/Basemap";
import WebTileLayer from "@arcgis/core/layers/WebTileLayer";
export function addBaseMapToggle(baseMapSettings) {
    let googleLayerStallite = new WebTileLayer({
        urlTemplate: "http://mt{subDomain}.google.com/vt/lyrs=s,h&hl=en&gl=en&x={col}&y={row}&z={level}&s=png&hl=ar-EG&apistyle=s.t%3A17%7Cs.e%3Al.t%7Cp.v%3Aoff%2Cs.t%3A6%7Cs.e%3Al%7Cp.v%3Aoff",
        subDomains: ['0', '1', '2', '3'],
        title: "خريطة صورة فضائية",
        id: "googleBaseMapStallite"
    });
    let googleMapStallite = new Basemap({
        baseLayers: [googleLayerStallite],
        title: "صورة فضائية",
        id: "basemapGoogleStallite",
        thumbnailUrl: baseMapSettings.thumbnailUrl
    });
    let basemap = new BasemapToggle({
        view: baseMapSettings.mapView,
        nextBasemap: baseMapSettings.esriBaseMapType === 'googleStallite' ? googleMapStallite : baseMapSettings.esriBaseMapType, //'satellite' //customeBasemap,  //'satellite',
    });
    baseMapSettings.mapView.ui.add(basemap, baseMapSettings.basemapPosition);
    baseMapSettings.toggled == true ? basemap.toggle() : null;
    basemap.toggle();
    basemap.on('toggle', (event) => {
        baseMapSettings.callbackWhenToggled(event);
    });
}
